/** Keep first row per numeric id (API may return duplicate domain/question rows). */
export function dedupeById<T extends { id: number }>(rows: readonly T[]): T[] {
  const seen = new Set<number>();
  const out: T[] = [];
  for (const row of rows) {
    if (seen.has(row.id)) continue;
    seen.add(row.id);
    out.push(row);
  }
  return out;
}
